// 创建输入框
export const copyToClipboard = async (str) => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(str);
  }
  return true;
};
